import styled from 'styled-components'
import { Hr } from 'ui/components/Hr'

export const WrappedHr = styled(Hr)`
  margin-bottom: 21px;
`
